import dayjs from '~/timeInit';

import { LUX_PLUS_SCHEDULE } from '~/consts/schedule';

type Schedule = Pick<App.Offer['brand_schedules'][number], 'type' | 'brand' | 'region' | 'start' | 'end'>;

export function getLuxPlusScheduleDates(
  schedules: ReadonlyArray<Schedule> | undefined,
  brand: string,
  region: string,
): Array<string> {
  const matchingSchedules = (schedules ?? []).filter(
    (schedule) =>
      schedule.type === LUX_PLUS_SCHEDULE &&
      schedule.brand === brand &&
      schedule.region === region &&
      schedule.start &&
      schedule.end &&
      dayjs(schedule.start).isValid() &&
      dayjs(schedule.end).isValid() &&
      !dayjs(schedule.end).isBefore(dayjs(schedule.start)),
  );

  // Keep separate windows separate rather than implying availability through a gap.
  return Array.from(
    new Set(
      matchingSchedules
        .sort((a, b) => dayjs(a.start).valueOf() - dayjs(b.start).valueOf())
        .map(
          (schedule) => `${dayjs(schedule.start).format('DD/MM/YYYY')} - ${dayjs(schedule.end).format('DD/MM/YYYY')}`,
        ),
    ),
  );
}
